export interface Student {
  id: string
  name: string
  studentId: string
  class: string
  gpa: string
  careerPath: string
  careerIcon: string
  guardianName: string
  guardianPhone: string
  guardianEmail: string
  initials: string
  initialsColor: string
}

export const nigerianClasses = ["JSS 1", "JSS 2", "JSS 3", "SSS 1", "SSS 2", "SSS 3"]

export const careerPaths = [
  { name: "Software Engineer", icon: "code" },
  { name: "Medicine", icon: "stethoscope" },
  { name: "Law", icon: "gavel" },
  { name: "Architecture", icon: "building" },
  { name: "Engineering", icon: "cog" },
  { name: "Teaching", icon: "book-open" },
  { name: "Business", icon: "briefcase" },
  { name: "Arts & Design", icon: "palette" },
  { name: "Agriculture", icon: "sprout" },
  { name: "Accounting", icon: "calculator" },
]

export const initialStudents: Student[] = [
  {
    id: "1",
    name: "Emeka Okonkwo",
    studentId: "ESCP-2023-001",
    class: "JSS 3",
    gpa: "4.5",
    careerPath: "Software Engineer",
    careerIcon: "code",
    guardianName: "Mrs. Okonkwo",
    guardianPhone: "+234 803 123 4567",
    guardianEmail: "okonkwo.guardian@gmail.com",
    initials: "EO",
    initialsColor: "orange",
  },
  // {
  //   id: "2",
  //   name: "Zainab Abiola",
  //   studentId: "ESCP-2023-045",
  //   class: "SSS 1",
  //   gpa: "3.8",
  //   careerPath: "Medicine",
  //   careerIcon: "stethoscope",
  //   guardianName: "Mr. Abiola",
  //   guardianPhone: "+234 705 987 6543",
  //   guardianEmail: "abiola.guardian@gmail.com",
  //   initials: "ZA",
  //   initialsColor: "purple",
  // },
  // {
  //   id: "3",
  //   name: "Chioma Adeyemi",
  //   studentId: "ESCP-2023-089",
  //   class: "JSS 2",
  //   gpa: "4.1",
  //   careerPath: "Law",
  //   careerIcon: "gavel",
  //   guardianName: "Dr. Adeyemi",
  //   guardianPhone: "+234 812 345 6789",
  //   guardianEmail: "adeyemi.guardian@gmail.com",
  //   initials: "CA",
  //   initialsColor: "pink",
  // },
  // {
  //   id: "4",
  //   name: "Tunde Bakare",
  //   studentId: "ESCP-2023-112",
  //   class: "SSS 2",
  //   gpa: "4.8",
  //   careerPath: "Architecture",
  //   careerIcon: "building",
  //   guardianName: "Mrs. Bakare",
  //   guardianPhone: "+234 901 234 5678",
  //   guardianEmail: "bakare.guardian@gmail.com",
  //   initials: "TB",
  //   initialsColor: "indigo",
  // },
  // {
  //   id: "5",
  //   name: "Fatima Mohammed",
  //   studentId: "ESCP-2023-056",
  //   class: "JSS 1",
  //   gpa: "3.9",
  //   careerPath: "Teaching",
  //   careerIcon: "book-open",
  //   guardianName: "Mr. Mohammed",
  //   guardianPhone: "+234 806 789 0123",
  //   guardianEmail: "mohammed.guardian@gmail.com",
  //   initials: "FM",
  //   initialsColor: "teal",
  // },
  // {
  //   id: "6",
  //   name: "Chukwudi Eze",
  //   studentId: "ESCP-2023-078",
  //   class: "SSS 3",
  //   gpa: "4.3",
  //   careerPath: "Engineering",
  //   careerIcon: "cog",
  //   guardianName: "Mrs. Eze",
  //   guardianPhone: "+234 813 456 7890",
  //   guardianEmail: "eze.guardian@gmail.com",
  //   initials: "CE",
  //   initialsColor: "blue",
  // },
  // {
  //   id: "7",
  //   name: "Blessing Okafor",
  //   studentId: "ESCP-2023-134",
  //   class: "JSS 3",
  //   gpa: "4.0",
  //   careerPath: "Business",
  //   careerIcon: "briefcase",
  //   guardianName: "Mr. Okafor",
  //   guardianPhone: "+234 805 234 5678",
  //   guardianEmail: "okafor.guardian@gmail.com",
  //   initials: "BO",
  //   initialsColor: "green",
  // },
  // {
  //   id: "8",
  //   name: "Ibrahim Suleiman",
  //   studentId: "ESCP-2023-167",
  //   class: "SSS 1",
  //   gpa: "3.7",
  //   careerPath: "Agriculture",
  //   careerIcon: "sprout",
  //   guardianName: "Mrs. Suleiman",
  //   guardianPhone: "+234 807 890 1234",
  //   guardianEmail: "suleiman.guardian@gmail.com",
  //   initials: "IS",
  //   initialsColor: "amber",
  // },
  // {
  //   id: "9",
  //   name: "Ngozi Chukwuma",
  //   studentId: "ESCP-2023-201",
  //   class: "JSS 2",
  //   gpa: "4.2",
  //   careerPath: "Arts & Design",
  //   careerIcon: "palette",
  //   guardianName: "Dr. Chukwuma",
  //   guardianPhone: "+234 809 012 3456",
  //   guardianEmail: "chukwuma.guardian@gmail.com",
  //   initials: "NC",
  //   initialsColor: "red",
  // },
  // {
  //   id: "10",
  //   name: "Oluwaseun Musa",
  //   studentId: "ESCP-2023-245",
  //   class: "SSS 2",
  //   gpa: "4.4",
  //   careerPath: "Accounting",
  //   careerIcon: "calculator",
  //   guardianName: "Mrs. Musa",
  //   guardianPhone: "+234 810 234 5678",
  //   guardianEmail: "musa.guardian@gmail.com",
  //   initials: "OM",
  //   initialsColor: "cyan",
  // },
]
